import React from 'react';
import { BacktestingExceptionsGrid as BacktestingExceptionsGridContainer } from 'shared/components/DataGrid/BacktestingExceptionsGrid';
import { mapBacktestingExceptionsGrid } from 'shared/mappers';
import { handleOnCellPrepared } from '../utils';
import TopBacktestingGridDataFromApi from '../mock/BacktestingExceptionsMockedData.json';
import './BacktestingExceptionsGrid.scss';

export const BacktestingExceptionsGrid: React.FC = () => {
  const tableData = mapBacktestingExceptionsGrid({
    data: TopBacktestingGridDataFromApi,
  });

  return (
    <div className="backtesting-exceptions-grid">
      <BacktestingExceptionsGridContainer
        dataFromApi={tableData}
        onCellPrepared={handleOnCellPrepared}
      />
    </div>
  );
};
